import { FC, Fragment, useReducer } from 'react';

import { Plus } from 'lucide-react';
import { toast } from 'sonner';
import useSWRMutation from 'swr/mutation';

import Button from '@mui/material/Button';

import { initialValues } from '../form';
import { TournamentGroupFormDialog } from '../tournamentGroupFormDialog/TournamentGroupFormDialog';

import { tournamentGroupService } from 'v2/api/tournamentGroupService';
import { TournamentGroupForm } from 'v2/types/TournamentGroupModel';
import { handleHttpError } from 'v2/utils';

interface AddTournamentGroupButtonProps {
  onSuccess: VoidFunction;
}

export const AddTournamentGroupButton: FC<AddTournamentGroupButtonProps> = ({ onSuccess }) => {
  const [isOpen, setOpen] = useReducer((state) => !state, false);

  const { trigger: triggerCreate, isMutating: isMutatingCreate } = useSWRMutation(
    'createTournamentGroup',
    tournamentGroupService.createTournamentGroup,
    {
      onSuccess: () => {
        onSuccess();
        toast.success('New tournament group has been successfully created');
        setOpen();
      },
      onError: handleHttpError,
    }
  );

  const handleSubmit = (values: TournamentGroupForm, resetForm: VoidFunction) => {
    triggerCreate(values).then(() => resetForm());
  };

  return (
    <Fragment>
      <Button onClick={setOpen} startIcon={<Plus />} variant="contained" size="large">
        Add Tournament Group
      </Button>

      <TournamentGroupFormDialog
        title="Set Up New Tournament Group"
        isOpen={isOpen}
        onClose={setOpen}
        initialValues={initialValues}
        isSubmitting={isMutatingCreate}
        onSubmit={handleSubmit}
      />
    </Fragment>
  );
};
